module.exports = __webpack_public_path__ + "img/IMG_1673.34798846.jpeg";